import { useState, useEffect, memo } from 'react'
import axios from 'axios';
import { Box } from '@mui/material';

const TopDonators = () => {
  const { REACT_APP_API_URL } = process.env;
  const [topDonators, setTopDonators] = useState([]);

  useEffect(() => {
    axios.get(`${REACT_APP_API_URL}/top-donator`).then((result) => {
      setTopDonators(result.data);
    })
  }, [REACT_APP_API_URL])

  return (
    <>
      {topDonators.length > 0 && (
        <Box
          sx={{
            backgroundImage: 'linear-gradient(180deg, #1c1d22e3, #06050acf)',
            border: '1px solid rgba(255, 0, 0, 0.233)',
            padding: '30px',
            boxShadow: '0 0 40px 0 rgb(0 0 0 / 25%)',
            flex: '1',
            textAlign: 'center'
          }}
        >
          <h2>Top Donators Of The Month</h2>
          <ol style={{ marginTop: 16, }}>
            {topDonators.map((d, i) => (
              <li key={d.username} style={{ margin: "8px 0", fontWeight: 'normal', listStyleType: 'decimal' }}>{d.username.substring(0, 1).toUpperCase()}{d.username.substring(1)}</li>
            ))}
          </ol>
        </Box>
      )}</>
  )
}

export default memo(TopDonators)